module.exports = __webpack_public_path__ + "static/media/Dashboard.2e766b82.png";